import { Outlet } from "react-router-dom";

import { SignedInHeader } from "../home/Header";
import classes from "./MainLayout.module.css";


export function MainLayout() {

  return (
    <div className={classes.root}>
      <SignedInHeader />
      <main className={classes.content}>
        <Outlet />
      </main>
    </div>
  );
}
